// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Roobert-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Roobert-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Roobert-Heavy.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./Roobert-Heavy.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./Roobert-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./Roobert-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./Roobert-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./Roobert-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./Roobert-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./Roobert-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./Roobert-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./Roobert-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./Roobert-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./Roobert-HeavyItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./Roobert-HeavyItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./Roobert-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./Roobert-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./Roobert-RegularItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./Roobert-RegularItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./Roobert-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./Roobert-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./Roobert-SemiBoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./Roobert-SemiBoldItalic.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Roobert';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Roobert';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Roobert';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Roobert';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Roobert';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Roobert';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Roobert';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Roobert';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff');
    font-weight: 900;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Roobert';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Roobert';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('woff');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Roobert';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('woff');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Roobert';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('woff');
    font-weight: 600;
    font-style: italic;
    font-display: swap;
}`, "",{"version":3,"sources":["webpack://./src/fonts/Roobert/RoobertFont.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB;8DACgD;IAChD,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;8DAC8C;IAC9C,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,4DAAwD;IACxD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;8DACmD;IACnD,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;8DAC8C;IAC9C,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DACiD;IACjD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DAC6C;IAC7C,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DACoD;IACpD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DAC+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DACsD;IACtD,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DACoD;IACpD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DACuD;IACvD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":["@font-face {\n    font-family: 'Roobert';\n    src: url('./Roobert-Regular.woff2') format('woff2'),\n        url('./Roobert-Regular.woff') format('woff');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Roobert';\n    src: url('./Roobert-Heavy.woff2') format('woff2'),\n        url('./Roobert-Heavy.woff') format('woff');\n    font-weight: 900;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Roobert';\n    src: url('./Roobert-MediumItalic.woff2') format('woff2');\n    font-weight: 500;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Roobert';\n    src: url('./Roobert-BoldItalic.woff2') format('woff2'),\n        url('./Roobert-BoldItalic.woff') format('woff');\n    font-weight: bold;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Roobert';\n    src: url('./Roobert-Light.woff2') format('woff2'),\n        url('./Roobert-Light.woff') format('woff');\n    font-weight: 300;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Roobert';\n    src: url('./Roobert-SemiBold.woff2') format('woff2'),\n        url('./Roobert-SemiBold.woff') format('woff');\n    font-weight: 600;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Roobert';\n    src: url('./Roobert-Bold.woff2') format('woff2'),\n        url('./Roobert-Bold.woff') format('woff');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Roobert';\n    src: url('./Roobert-HeavyItalic.woff2') format('woff2'),\n        url('./Roobert-HeavyItalic.woff') format('woff');\n    font-weight: 900;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Roobert';\n    src: url('./Roobert-Medium.woff2') format('woff2'),\n        url('./Roobert-Medium.woff') format('woff');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Roobert';\n    src: url('./Roobert-RegularItalic.woff2') format('woff2'),\n        url('./Roobert-RegularItalic.woff') format('woff');\n    font-weight: normal;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Roobert';\n    src: url('./Roobert-LightItalic.woff2') format('woff2'),\n        url('./Roobert-LightItalic.woff') format('woff');\n    font-weight: 300;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Roobert';\n    src: url('./Roobert-SemiBoldItalic.woff2') format('woff2'),\n        url('./Roobert-SemiBoldItalic.woff') format('woff');\n    font-weight: 600;\n    font-style: italic;\n    font-display: swap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
